import * as React from "react";
import { IconBase, IIconBase } from "../IconBase";

export const BatteryIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Battery</title>
    <path d="M 4 13 H 10 V 35 H 4 V 13 Z M 12 13 H 18 V 35 H 12 V 13 Z M 26 13 H 20 V 35 H 26 V 13 Z M 28 13 H 34 V 35 H 28 V 13 Z M 42 13 V 19 L 44 21 V 27 L 42 29 V 35 H 36 V 13 H 42 Z" />
  </IconBase>
);
